var kind       = require("enyo/kind"),
    CoreObject = require("enyo/CoreObject");

/**
 * [Attractor]{@link enyo-anim.Attractor} is used to animate a [Scalar]{@link
 * enyo-anim.Scalar} towards a new value.
 *
 * For the sake of performance, we don't implement any type checking. Please
 * supply the documented types parameter types only.
 *
 * @class   enyo-anim.Attractor
 * @extends enyo.Object
 * @public
 */
module.exports = kind(/** @lends enyo-anim.Attractor.prototype */ {

    /**
     * @private
     */
    name: "enyo-anim.Attractor",

    /**
     * @private
     */
    kind: CoreObject,

    /**
     * Current value.
     *
     * @type    {?Number}
     * @default null
     * @public
     */
    value: null,

    /**
     * Attraction multiplier. Value of 0 means no attraction, value of 1 means
     * instant teleportation.
     *
     * @type    {number}
     * @default 0.02
     * @public
     */
    attraction: 0.02,

    /**
     * Multiply the value, velocity and acceleration.
     *
     * @param {number}  multiplier  The multiplier
     * @public
     */
    resize: function(multiplier) {
        var value = this.value;

        // Skip if multiplier is 1;
        if (multiplier !== 1) {
            this.value = value !== null ? value * multiplier : value;
        }
    },

    /**
     * Resets value to null.
     *
     * @public
     */
    clear: function() {
        this.value = null;
    }

});
